import AfghanistanMapLoader from "./AfghanistanMapLoader.js";
import EasternEuropeMapLoader from "./EasternEuropeMapLoader.js";
import IraqMapLoader from "./IraqMapLoader.js";
import SevenTwentyMapLoader from "./SevenTwentyMapLoader.js";
import USAMapLoader from "./USAMapLoader.js";
import USATexas23MapLoader from "./USATexas23MapLoader.js";
import VenezuelaMapLoader from "./VenezuelaMapLoader.js";

const MapPreLoader = (baseMap) => {
	if (baseMap === "iraq") {
		IraqMapLoader.preload();
	} else if (baseMap === "venezuela") {
		VenezuelaMapLoader.preload();
	} else if (baseMap === "sevenTwenty" || baseMap === "bcbs") {
		SevenTwentyMapLoader.preload();
	} else if (baseMap === "gec" || baseMap === "balticsDemo" || baseMap === "gec_analyst") {
		EasternEuropeMapLoader.preload();
	} else if (baseMap === "uscc" || baseMap === "sevenTwenty_uscc") {
		USATexas23MapLoader.preload();
	} else if (baseMap === "craftsman" || baseMap === "usip") {
		AfghanistanMapLoader.preload();
	} else {
		USAMapLoader.preload();
	}
};

export default MapPreLoader;
